import JsonApiResource from './JsonApiResource'

export default class Playable extends JsonApiResource {
  constructor(json_data, json_included) {
    super(json_data, json_included)
    this.playableState = this.attributes['playable-state']
    this.distanceTo = this.attributes['distance-to']
  }
}
